<template>
    <div>
        <buttonlist
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="cost_year" :label="$t('getapi[1974]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="cost_month" :label="$t('getapi[1975]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1196]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[1197]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="ipo_code" :label="$t('getapi[4283]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="order_type" :label="$t('getapi[4639]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[4754]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_date" :label="$t('getapi[7576]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[574]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="inv_measure" :label="$t('getapi[1340]')"></el-table-column>
            <el-table-column prop="receive_qty" :label="$t('getapi[7577]')" align="right">
                <template slot-scope="scope">
                    {{(scope.row.receive_qty + scope.row.self_bad_qty) | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="cost_unit" :label="$t('getapi[2186]')" align="right">
                <template slot-scope="scope">
                    {{ scope.row.cost_unit | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="cost_amount" :label="$t('getapi[2187]')" align="right">
                <template slot-scope="scope">
                    {{ scope.row.cost_amount | thousandth}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[6211]')"></el-table-column>
        </el-table>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="IssEstimateInfo" ref="ser" @getser="serclick"></serce>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_issestimate',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-180
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_issestimate'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
            };
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        methods: {
            authority() {
                let that = this
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_issestimate',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'IssEstimateInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Fin/Estimate/GetIssEstimateView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.loading = true
                that.$http.urlpost('/Fin/Estimate/GetIssEstimateViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        that.loading = false
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    /deep/.yellow{
        background:#fff7bf
    }
    /deep/.green{
        background: #c4ffaf
    }
    /deep/.purple{
        background: #edc6ff
    }
</style>
